import { api } from "@/lib/api";

export const financeApi = {
  meta: () => api.get("/finance/meta").then((r) => r.data),
  stats: () => api.get("/finance/stats").then((r) => r.data),
  invoiceable: () => api.get("/finance/invoiceable").then((r) => r.data),
  customers: () => api.get("/finance/customers").then((r) => r.data),

  listInvoices: (params) => api.get("/finance/invoices", { params }).then((r) => r.data),
  getInvoice: (id) => api.get(`/finance/invoices/${id}`).then((r) => r.data),
  createInvoice: (body) => api.post("/finance/invoices", body).then((r) => r.data),
  updateInvoice: (id, body) => api.put(`/finance/invoices/${id}`, body).then((r) => r.data),
  postInvoice: (id) => api.post(`/finance/invoices/${id}/post`).then((r) => r.data),
  setInvoiceStatus: (id, status, note) => api.patch(`/finance/invoices/${id}/status`, { status, note }).then((r) => r.data),

  listPayments: (params) => api.get("/finance/payments", { params }).then((r) => r.data),
  getPayment: (id) => api.get(`/finance/payments/${id}`).then((r) => r.data),
  createPayment: (body) => api.post("/finance/payments", body).then((r) => r.data),
  openInvoices: (cid) => api.get(`/finance/customers/${cid}/open-invoices`).then((r) => r.data),

  createNote: (body) => api.post("/finance/notes", body).then((r) => r.data),

  outstanding: () => api.get("/finance/outstanding").then((r) => r.data),
  aging: () => api.get("/finance/aging").then((r) => r.data),
  gstSummary: () => api.get("/finance/gst-summary").then((r) => r.data),
  valuation: () => api.get("/finance/valuation").then((r) => r.data),
  ledger: (params) => api.get("/finance/ledger", { params }).then((r) => r.data),
};

export const INVOICE_STATUS_STYLE = {
  Draft: "bg-slate-100 text-slate-700",
  "Payment Pending": "bg-amber-50 text-amber-700 border border-amber-200",
  "Partially Paid": "bg-blue-50 text-blue-700 border border-blue-200",
  Paid: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Closed: "bg-slate-200 text-slate-500",
  Cancelled: "bg-rose-50 text-rose-700 border border-rose-200",
};

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
